export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "ar-AE": {
        "notification": {
          "emailOTPNotVerified": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])},
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["لا يمكن تأكيد رمز المصادقة."])}
          },
          "verifyEmailOTP": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["لا يمكن تأكيد رمز المصادقة."])},
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])},
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["رمز المصادقة غير صالح"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])}
            }
          },
          "emailSent": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عمل ناجح"])},
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تم إرسال رمز المصادقة عبر البريد الإلكتروني. يمكن استخدامه مرة واحدة فقط وضمن فترة زمنية محدودة للتسجيل."])}
          },
          "sendEmail": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تم إرسال رمز المصادقة عبر البريد الإلكتروني. يمكن استخدامه مرة واحدة فقط وضمن فترة زمنية محدودة للتسجيل."])},
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["تم إرسال رمز التحقق عبر البريد الإلكتروني إلى ", _interpolate(_named("primaryEmailAddressPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عمل ناجح"])}
            },
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عمل ناجح"])}
          }
        },
        "resendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أرسل مرة أخرى"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أدخل وتأكد من استلام رمز المصادقة."])}
        },
        "emailOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أدخل رمز التحقق"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["كود التوثيق من البريد الإلكتروني"])}
          }
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["إعادة الإرسال في ", _interpolate(_named("secondsPlaceholder")), " ثوان"])}
        },
        "emailOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["رمز المصادقة عن طريق البريد الإلكتروني"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تأكيد"])}
        }
      },
      "ar-DZ": {
        "notification": {
          "emailOTPNotVerified": {
            
          },
          "verifyEmailOTP": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["رمز التوثيق غير صالح"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])}
            }
          },
          "emailSent": {
            
          },
          "sendEmail": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["تم إرسال كود التوثيق عبر البريد الإلكتروني إلى ", _interpolate(_named("primaryEmailAddressPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عمل ناجح"])}
            }
          }
        },
        "resendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أرسل مرة أخرى"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أدخل وتأكد من استلام رمز المصادقة."])}
        },
        "emailOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أدخل رمز التحقق"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["كود التوثيق من البريد الإلكتروني"])}
          }
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["إعادة الإرسال في ", _interpolate(_named("secondsPlaceholder")), " ثوان"])}
        },
        "emailOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["رمز المصادقة عن طريق البريد الإلكتروني"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تأكيد"])}
        }
      },
      "ar-EG": {
        "notification": {
          "emailOTPNotVerified": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])},
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["لا يمكن تأكيد رمز المصادقة."])}
          },
          "verifyEmailOTP": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["لا يمكن تأكيد رمز المصادقة."])},
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])},
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الرمز التوثيقي غير صالح"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])}
            }
          },
          "emailSent": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عمل ناجح"])},
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تم إرسال رمز المصادقة عبر البريد الإلكتروني. يمكن استخدامه مرة واحدة فقط وضمن فترة زمنية محدودة للتسجيل."])}
          },
          "sendEmail": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تم إرسال رمز المصادقة عبر البريد الإلكتروني. يمكن استخدامه مرة واحدة فقط وضمن فترة زمنية محدودة للتسجيل."])},
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["تم إرسال كود التحقق عبر البريد الإلكتروني إلى ", _interpolate(_named("primaryEmailAddressPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عمل ناجح"])}
            },
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عمل ناجح"])}
          }
        },
        "resendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أرسل مرة أخرى"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أدخل وتأكد من استلام رمز المصادقة."])}
        },
        "emailOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أدخل رمز التحقق"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["كود التوثيق من البريد الإلكتروني"])}
          }
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["إعادة الإرسال في ", _interpolate(_named("secondsPlaceholder")), " ثوان"])}
        },
        "emailOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["رمز المصادقة عن طريق البريد الإلكتروني"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تأكيد"])}
        }
      },
      "ar-LB": {
        "notification": {
          "emailOTPNotVerified": {
            
          },
          "verifyEmailOTP": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الرمز التوثيقي غير صالح"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])}
            }
          },
          "emailSent": {
            
          },
          "sendEmail": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["تم إرسال كود التأكيد بواسطة البريد الإلكتروني إلى ", _interpolate(_named("primaryEmailAddressPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عمل ناجح"])}
            }
          }
        },
        "resendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أرسل مرة أخرى"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أدخل وتأكد من استلام رمز المصادقة."])}
        },
        "emailOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أدخل رمز التحقق"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["كود التوثيق من البريد الإلكتروني"])}
          }
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["إعادة الإرسال في ", _interpolate(_named("secondsPlaceholder")), " ثواني"])}
        },
        "emailOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["رمز المصادقة عن طريق البريد الإلكتروني"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تأكيد"])}
        }
      },
      "ar-MA": {
        "notification": {
          "emailOTPNotVerified": {
            
          },
          "verifyEmailOTP": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["كود التوثيق غير صالح"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])}
            }
          },
          "emailSent": {
            
          },
          "sendEmail": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["تم إرسال رمز التحقق بالبريد الإلكتروني إلى ", _interpolate(_named("primaryEmailAddressPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عمل ناجح"])}
            }
          }
        },
        "resendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أرسل مرة أخرى"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أدخل وتأكد من استلام رمز المصادقة."])}
        },
        "emailOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ادخل رمز التأكيد"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["كود التوثيق من البريد الإلكتروني"])}
          }
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["إعادة الإرسال في ", _interpolate(_named("secondsPlaceholder")), " ثوان"])}
        },
        "emailOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["رمز المصادقة عن طريق البريد الإلكتروني"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تأكيد"])}
        }
      },
      "ar-SA": {
        "notification": {
          "emailOTPNotVerified": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])},
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["لا يمكن تأكيد رمز المصادقة."])}
          },
          "verifyEmailOTP": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["لا يمكن تأكيد رمز المصادقة."])},
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])},
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["رمز التحقق غير صالح"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])}
            }
          },
          "emailSent": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عمل ناجح"])},
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تم إرسال رمز المصادقة عبر البريد الإلكتروني. يمكن استخدامه مرة واحدة فقط وضمن فترة زمنية محدودة للتسجيل."])}
          },
          "sendEmail": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تم إرسال رمز المصادقة عبر البريد الإلكتروني. يمكن استخدامه مرة واحدة فقط وضمن فترة زمنية محدودة للتسجيل."])},
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["تم إرسال كود التحقق عبر البريد الإلكتروني إلى ", _interpolate(_named("primaryEmailAddressPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عمل ناجح"])}
            },
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عمل ناجح"])}
          }
        },
        "resendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أعد الإرسال"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أدخل وتأكد من استلام رمز المصادقة."])}
        },
        "emailOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أدخل رمز التحقق"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["كود التوثيق من البريد الإلكتروني"])}
          }
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["إعادة الإرسال في ", _interpolate(_named("secondsPlaceholder")), " ثوان"])}
        },
        "emailOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["رمز المصادقة عن طريق البريد الإلكتروني"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تأكيد"])}
        }
      },
      "ar-SY": {
        "notification": {
          "emailOTPNotVerified": {
            
          },
          "verifyEmailOTP": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["كود التوثيق غير صالح"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])}
            }
          },
          "emailSent": {
            
          },
          "sendEmail": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["تم إرسال كود التأكيد عبر البريد الإلكتروني إلى ", _interpolate(_named("primaryEmailAddressPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عمل ناجح"])}
            }
          }
        },
        "resendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أرسل مرة أخرى"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أدخل وتأكد من استلام رمز المصادقة."])}
        },
        "emailOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أدخل رمز التحقق"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["كود التوثيق من البريد الإلكتروني"])}
          }
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["إعادة الإرسال في ", _interpolate(_named("secondsPlaceholder")), " ثوان"])}
        },
        "emailOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["رمز المصادقة عن طريق البريد الإلكتروني"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تأكيد"])}
        }
      },
      "ar-TN": {
        "notification": {
          "emailOTPNotVerified": {
            
          },
          "verifyEmailOTP": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["كود التوثيق غير صالح"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])}
            }
          },
          "emailSent": {
            
          },
          "sendEmail": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["تم إرسال كود التوثيق عبر البريد الإلكتروني إلى ", _interpolate(_named("primaryEmailAddressPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عمل ناجح"])}
            }
          }
        },
        "resendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أرسل مرة أخرى"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أدخل وتأكد من استلام رمز المصادقة."])}
        },
        "emailOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أدخل رمز التحقق"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["كود التوثيق من البريد الإلكتروني"])}
          }
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["إعادة الإرسال في ", _interpolate(_named("secondsPlaceholder")), " ثواني"])}
        },
        "emailOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["رمز المصادقة عن طريق البريد الإلكتروني"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تأكيد"])}
        }
      },
      "bg-BG": {
        "notification": {
          "emailOTPNotVerified": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["грешка"])},
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Кодът за удостоверяване не може да бъде потвърден."])}
          },
          "verifyEmailOTP": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Кодът за удостоверяване не може да бъде потвърден."])},
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["грешка"])},
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Кодът за удостоверяване е невалиден"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["грешка"])}
            }
          },
          "emailSent": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Успешно действие"])},
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Кодът за удостоверяване беше изпратен по имейл. Може да се използва само веднъж и в рамките на ограничено време за регистрация."])}
          },
          "sendEmail": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Кодът за удостоверяване беше изпратен по имейл. Може да се използва само веднъж и в рамките на ограничено време за регистрация."])},
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Кодът за удостоверяване е изпратен по имейл до ", _interpolate(_named("primaryEmailAddressPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Успешно действие"])}
            },
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Успешно действие"])}
          }
        },
        "resendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Изпрати отново"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Въведете и потвърдете получения код за удостоверяване."])}
        },
        "emailOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Въведете код за удостоверяване"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Код за удостоверяване от имейла"])}
          }
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Преизпрати след ", _interpolate(_named("secondsPlaceholder")), " секунди"])}
        },
        "emailOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Код за удостоверяване по имейл"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Потвърждение"])}
        }
      },
      "bs-BA": {
        "notification": {
          "emailOTPNotVerified": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Greška"])},
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nije moguće potvrditi autentifikacijski kôd."])}
          },
          "verifyEmailOTP": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nije moguće potvrditi autentifikacijski kôd."])},
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Greška"])},
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kod za autentifikaciju je nevažeći"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Greška"])}
            }
          },
          "emailSent": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uspješno obavljeno"])},
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kod za autentifikaciju je poslan putem e-pošte. Može se koristiti samo jednom iu ograničenom vremenu za registraciju."])}
          },
          "sendEmail": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kod za autentifikaciju je poslan putem e-pošte. Može se koristiti samo jednom iu ograničenom vremenu za registraciju."])},
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Autentifikacijski kod poslan je e-mailom na ", _interpolate(_named("primaryEmailAddressPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uspješno obavljeno"])}
            },
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uspješno obavljeno"])}
          }
        },
        "resendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pošalji ponovo"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unesite i potvrdite primljeni kod za autentifikaciju."])}
        },
        "emailOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unesite kod za autentifikaciju"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kod za autentifikaciju iz e-maila"])}
          }
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Ponovno pošalji za ", _interpolate(_named("secondsPlaceholder")), " sekundi"])}
        },
        "emailOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikacijski kod e-poštom"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Potvrdite"])}
        }
      },
      "cs-CZ": {
        "notification": {
          "emailOTPNotVerified": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chyba"])},
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nelze potvrdit ověřovací kód."])}
          },
          "verifyEmailOTP": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nelze potvrdit ověřovací kód."])},
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chyba"])},
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ověřovací kód je neplatný"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chyba"])}
            }
          },
          "emailSent": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Úspěšná akce"])},
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ověřovací kód byl zaslán e-mailem. Lze jej použít pouze jednou a během omezené doby pro registraci."])}
          },
          "sendEmail": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ověřovací kód byl zaslán e-mailem. Lze jej použít pouze jednou a během omezené doby pro registraci."])},
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Ověřovací kód byl odeslán e-mailem na ", _interpolate(_named("primaryEmailAddressPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Úspěšná akce"])}
            },
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Úspěšná akce"])}
          }
        },
        "resendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Poslat znovu"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zadejte a potvrďte přijatý ověřovací kód."])}
        },
        "emailOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zadejte ověřovací kód"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentizační kód z e-mailu"])}
          }
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Znovu odeslat za ", _interpolate(_named("secondsPlaceholder")), " sekundy"])}
        },
        "emailOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ověřovací kód e-mailem"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Potvrdit"])}
        }
      },
      "da-DK": {
        "notification": {
          "emailOTPNotVerified": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fejl"])},
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Godkendelseskoden kunne ikke bekræftes."])}
          },
          "verifyEmailOTP": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Godkendelseskoden kunne ikke bekræftes."])},
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fejl"])},
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Godkendelseskoden er ugyldig"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fejl"])}
            }
          },
          "emailSent": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vellykket handling"])},
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Godkendelseskoden blev sendt via e-mail. Den kan kun bruges én gang og inden for en begrænset tid til registrering."])}
          },
          "sendEmail": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Godkendelseskoden blev sendt via e-mail. Den kan kun bruges én gang og inden for en begrænset tid til registrering."])},
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Godkendelseskoden er sendt via e-mail til ", _interpolate(_named("primaryEmailAddressPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vellykket handling"])}
            },
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vellykket handling"])}
          }
        },
        "resendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Send igen"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Indtast og bekræft den modtagne godkendelseskode."])}
        },
        "emailOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Indtast godkendelseskode"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentificeringskode fra e-mail"])}
          }
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Gensend om ", _interpolate(_named("secondsPlaceholder")), " sekunder"])}
        },
        "emailOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Godkendelseskode via e-mail"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bekræft"])}
        }
      },
      "de-DE": {
        "notification": {
          "emailOTPNotVerified": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])},
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Der Authentifizierungscode konnte nicht bestätigt werden."])}
          },
          "verifyEmailOTP": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Der Authentifizierungscode konnte nicht bestätigt werden."])},
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])},
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Der Authentifizierungscode ist ungültig."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])}
            }
          },
          "emailSent": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erfolgreiche Aktion"])},
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Der Authentifizierungscode wurde per E-Mail gesendet. Er kann nur einmalig und innerhalb einer begrenzten Zeit für die Anmeldung verwendet werden."])}
          },
          "sendEmail": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Der Authentifizierungscode wurde per E-Mail gesendet. Er kann nur einmalig und innerhalb einer begrenzten Zeit für die Anmeldung verwendet werden."])},
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Der Authentifizierungscode wurde per E-Mail an ", _interpolate(_named("primaryEmailAddressPlaceholder")), " gesendet."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erfolgreiche Aktion"])}
            },
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erfolgreiche Aktion"])}
          }
        },
        "resendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erneut senden"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Empfangenen Authentifizierungscode eingeben und bestätigen."])}
        },
        "emailOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungscode eingeben"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungscode aus der E-Mail"])}
          }
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Erneut senden in ", _interpolate(_named("secondsPlaceholder")), " Sekunden"])}
        },
        "emailOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungscode per E-Mail"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bestätigen"])}
        }
      },
      "de-AT": {
        "notification": {
          "emailOTPNotVerified": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])},
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Der Authentifizierungscode konnte nicht bestätigt werden."])}
          },
          "verifyEmailOTP": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Der Authentifizierungscode konnte nicht bestätigt werden."])},
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])},
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Der Authentifizierungscode ist ungültig."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])}
            }
          },
          "emailSent": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erfolgreiche Aktion"])},
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Der Authentifizierungscode wurde per E-Mail gesendet. Er kann nur einmalig und innerhalb einer begrenzten Zeit für die Anmeldung verwendet werden."])}
          },
          "sendEmail": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Der Authentifizierungscode wurde per E-Mail gesendet. Er kann nur einmalig und innerhalb einer begrenzten Zeit für die Anmeldung verwendet werden."])},
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Der Authentifizierungscode wurde per E-Mail an ", _interpolate(_named("primaryEmailAddressPlaceholder")), " gesendet."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erfolgreiche Aktion"])}
            },
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erfolgreiche Aktion"])}
          }
        },
        "resendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erneut senden"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Empfangenen Authentifizierungscode eingeben und bestätigen."])}
        },
        "emailOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungscode eingeben"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungscode aus der E-Mail"])}
          }
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Erneut senden in ", _interpolate(_named("secondsPlaceholder")), " Sekunden"])}
        },
        "emailOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungscode per E-Mail"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bestätigen"])}
        }
      },
      "de-CH": {
        "notification": {
          "emailOTPNotVerified": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])},
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Der Authentifizierungscode konnte nicht bestätigt werden."])}
          },
          "verifyEmailOTP": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Der Authentifizierungscode konnte nicht bestätigt werden."])},
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])},
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Der Authentifizierungscode ist ungültig."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])}
            }
          },
          "emailSent": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erfolgreiche Aktion"])},
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Der Authentifizierungscode wurde per E-Mail gesendet. Er kann nur einmalig und innerhalb einer begrenzten Zeit für die Anmeldung verwendet werden."])}
          },
          "sendEmail": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Der Authentifizierungscode wurde per E-Mail gesendet. Er kann nur einmalig und innerhalb einer begrenzten Zeit für die Anmeldung verwendet werden."])},
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Der Authentifizierungscode wurde per E-Mail an ", _interpolate(_named("primaryEmailAddressPlaceholder")), " gesendet."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erfolgreiche Aktion"])}
            },
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erfolgreiche Aktion"])}
          }
        },
        "resendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erneut senden"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Empfangenen Authentifizierungscode eingeben und bestätigen."])}
        },
        "emailOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungscode eingeben"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungscode aus der E-Mail"])}
          }
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Erneut senden in ", _interpolate(_named("secondsPlaceholder")), " Sekunden"])}
        },
        "emailOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungscode per E-Mail"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bestätigen"])}
        }
      },
      "de-LU": {
        "notification": {
          "emailOTPNotVerified": {
            
          },
          "verifyEmailOTP": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Der Authentifizierungscode ist ungültig."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])}
            }
          },
          "emailSent": {
            
          },
          "sendEmail": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Der Authentifizierungscode wurde per E-Mail an ", _interpolate(_named("primaryEmailAddressPlaceholder")), " gesendet."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erfolgreiche Aktion"])}
            }
          }
        },
        "resendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erneut senden"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Empfangenen Authentifizierungscode eingeben und bestätigen."])}
        },
        "emailOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungscode eingeben"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungscode aus der E-Mail"])}
          }
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Erneut senden in ", _interpolate(_named("secondsPlaceholder")), " Sekunden"])}
        },
        "emailOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungscode per E-Mail"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bestätigen"])}
        }
      },
      "el-GR": {
        "notification": {
          "emailOTPNotVerified": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Σφάλμα"])},
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Δεν ήταν δυνατή η επιβεβαίωση του κωδικού ελέγχου ταυτότητας."])}
          },
          "verifyEmailOTP": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Δεν ήταν δυνατή η επιβεβαίωση του κωδικού ελέγχου ταυτότητας."])},
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Σφάλμα"])},
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ο κωδικός επαλήθευσης είναι άκυρος"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Σφάλμα"])}
            }
          },
          "emailSent": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιτυχημένη ενέργεια"])},
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ο κωδικός ελέγχου ταυτότητας στάλθηκε μέσω email. Μπορεί να χρησιμοποιηθεί μόνο μία φορά και εντός περιορισμένου χρόνου για εγγραφή."])}
          },
          "sendEmail": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ο κωδικός ελέγχου ταυτότητας στάλθηκε μέσω email. Μπορεί να χρησιμοποιηθεί μόνο μία φορά και εντός περιορισμένου χρόνου για εγγραφή."])},
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Ο κωδικός επαλήθευσης έχει αποσταλεί με email στο ", _interpolate(_named("primaryEmailAddressPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιτυχημένη ενέργεια"])}
            },
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιτυχημένη ενέργεια"])}
          }
        },
        "resendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Στείλε ξανά"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Εισαγάγετε και επιβεβαιώστε τον κωδικό ελέγχου ταυτότητας που λάβατε."])}
        },
        "emailOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Εισάγετε τον κωδικό επαλήθευσης"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Κωδικός επαλήθευσης από το email"])}
          }
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Επανάληψη αποστολής σε ", _interpolate(_named("secondsPlaceholder")), " δευτερόλεπτα"])}
        },
        "emailOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Κωδικός ελέγχου ταυτότητας μέσω email"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιβεβαίωση"])}
        }
      },
      "el-CY": {
        "notification": {
          "emailOTPNotVerified": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Σφάλμα"])},
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Δεν ήταν δυνατή η επιβεβαίωση του κωδικού ελέγχου ταυτότητας."])}
          },
          "verifyEmailOTP": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Δεν ήταν δυνατή η επιβεβαίωση του κωδικού ελέγχου ταυτότητας."])},
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Σφάλμα"])},
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ο κωδικός επαλήθευσης είναι άκυρος"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Σφάλμα"])}
            }
          },
          "emailSent": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιτυχημένη ενέργεια"])},
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ο κωδικός ελέγχου ταυτότητας στάλθηκε μέσω email. Μπορεί να χρησιμοποιηθεί μόνο μία φορά και εντός περιορισμένου χρόνου για εγγραφή."])}
          },
          "sendEmail": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ο κωδικός ελέγχου ταυτότητας στάλθηκε μέσω email. Μπορεί να χρησιμοποιηθεί μόνο μία φορά και εντός περιορισμένου χρόνου για εγγραφή."])},
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Ο κωδικός επαλήθευσης έχει αποσταλεί μέσω email στο ", _interpolate(_named("primaryEmailAddressPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιτυχημένη ενέργεια"])}
            },
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιτυχημένη ενέργεια"])}
          }
        },
        "resendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Στείλε ξανά"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Εισαγάγετε και επιβεβαιώστε τον κωδικό ελέγχου ταυτότητας που λάβατε."])}
        },
        "emailOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Εισάγετε τον κωδικό επαλήθευσης"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Κωδικός επαλήθευσης από το email"])}
          }
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Επανάληψη αποστολής σε ", _interpolate(_named("secondsPlaceholder")), " δευτερόλεπτα"])}
        },
        "emailOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Κωδικός ελέγχου ταυτότητας μέσω email"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιβεβαίωση"])}
        }
      },
      "en-GB": {
        "notification": {
          "emailOTPNotVerified": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])},
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The authentication code could not be confirmed."])}
          },
          "verifyEmailOTP": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The authentication code could not be confirmed."])},
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])},
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The authentication code is invalid."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])}
            }
          },
          "emailSent": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Successful action"])},
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The authentication code was sent via email. It can only be used once and within a limited time for registration."])}
          },
          "sendEmail": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The authentication code was sent via email. It can only be used once and within a limited time for registration."])},
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["The authentication code has been sent by email to ", _interpolate(_named("primaryEmailAddressPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Successful Action"])}
            },
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Successful action"])}
          }
        },
        "resendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Resend"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enter and confirm the authentication code received."])}
        },
        "emailOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enter authentication code"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentication Code from Email"])}
          }
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Resend in ", _interpolate(_named("secondsPlaceholder")), " Seconds"])}
        },
        "emailOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentication Code by Email"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirm"])}
        }
      },
      "en-IE": {
        "notification": {
          "emailOTPNotVerified": {
            
          },
          "verifyEmailOTP": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The authentication code is invalid."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])}
            }
          },
          "emailSent": {
            
          },
          "sendEmail": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["The authentication code has been sent by email to ", _interpolate(_named("primaryEmailAddressPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Successful Action"])}
            }
          }
        },
        "resendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Resend"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enter and confirm the authentication code received."])}
        },
        "emailOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enter authentication code"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentication Code from Email"])}
          }
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Resend in ", _interpolate(_named("secondsPlaceholder")), " Seconds"])}
        },
        "emailOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentication Code by Email"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirm"])}
        }
      },
      "en-US": {
        "notification": {
          "emailOTPNotVerified": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])},
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The authentication code could not be confirmed."])}
          },
          "verifyEmailOTP": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The authentication code could not be confirmed."])},
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])},
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The authentication code is invalid."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])}
            }
          },
          "emailSent": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Successful action"])},
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The authentication code was sent via e-mail. It can only be used once and within a limited time for logging in."])}
          },
          "sendEmail": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The authentication code was sent via e-mail. It can only be used once and within a limited time for logging in."])},
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["The authentication code has been sent by email to ", _interpolate(_named("primaryEmailAddressPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Successful Action"])}
            },
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Successful action"])}
          }
        },
        "resendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Resend"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enter and confirm the authentication code received."])}
        },
        "emailOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enter authentication code"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentication Code from Email"])}
          }
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Resend in ", _interpolate(_named("secondsPlaceholder")), " Seconds"])}
        },
        "emailOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentication Code by Email"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirm"])}
        }
      },
      "es-ES": {
        "notification": {
          "emailOTPNotVerified": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])},
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No se pudo confirmar el código de autenticación."])}
          },
          "verifyEmailOTP": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No se pudo confirmar el código de autenticación."])},
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])},
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["El código de autenticación es inválido"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])}
            }
          },
          "emailSent": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Listo"])},
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["El código de autenticación se envió por correo electrónico. Solo se puede usar una vez y dentro de un tiempo limitado para el registro."])}
          },
          "sendEmail": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["El código de autenticación se envió por correo electrónico. Solo se puede usar una vez y dentro de un tiempo limitado para el registro."])},
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["El código de autenticación ha sido enviado por correo electrónico a ", _interpolate(_named("primaryEmailAddressPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Listo"])}
            },
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Listo"])}
          }
        },
        "resendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enviar de nuevo"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Introduzca y confirme el código de autenticación recibido."])}
        },
        "emailOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ingrese el código de autenticación"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Código de autenticación del correo electrónico"])}
          }
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Volver a enviar en ", _interpolate(_named("secondsPlaceholder")), " segundos"])}
        },
        "emailOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Código de autenticación por correo electrónico"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmar"])}
        }
      },
      "et-EE": {
        "notification": {
          "emailOTPNotVerified": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Viga"])},
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentimiskoodi ei õnnestunud kinnitada."])}
          },
          "verifyEmailOTP": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentimiskoodi ei õnnestunud kinnitada."])},
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Viga"])},
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentimiskood on kehtetu"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Viga"])}
            }
          },
          "emailSent": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edukas tegevus"])},
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentimiskood saadeti meili teel. Seda saab registreerimiseks kasutada ainult üks kord ja piiratud aja jooksul."])}
          },
          "sendEmail": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentimiskood saadeti meili teel. Seda saab registreerimiseks kasutada ainult üks kord ja piiratud aja jooksul."])},
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Autentimiskood on saadetud e-kirjaga aadressile ", _interpolate(_named("primaryEmailAddressPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edukas tegevus"])}
            },
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edukas tegevus"])}
          }
        },
        "resendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Saada uuesti"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sisestage ja kinnitage saadud autentimiskood."])}
        },
        "emailOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sisestage autentimiskood"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-postist pärinev autentimiskood"])}
          }
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Saada uuesti ", _interpolate(_named("secondsPlaceholder")), " sekundi pärast"])}
        },
        "emailOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentimiskood e-posti teel"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kinnita"])}
        }
      },
      "fi-FI": {
        "notification": {
          "emailOTPNotVerified": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Virhe"])},
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Todennuskoodia ei voitu vahvistaa."])}
          },
          "verifyEmailOTP": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Todennuskoodia ei voitu vahvistaa."])},
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Virhe"])},
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Todennuskoodi on virheellinen"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Virhe"])}
            }
          },
          "emailSent": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Onnistunut toiminta"])},
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Todennuskoodi lähetettiin sähköpostitse. Sitä voidaan käyttää vain kerran ja rajoitetun ajan rekisteröintiä varten."])}
          },
          "sendEmail": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Todennuskoodi lähetettiin sähköpostitse. Sitä voidaan käyttää vain kerran ja rajoitetun ajan rekisteröintiä varten."])},
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Autentikointikoodi on lähetetty sähköpostitse osoitteeseen ", _interpolate(_named("primaryEmailAddressPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Onnistunut toiminta"])}
            },
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Onnistunut toiminta"])}
          }
        },
        "resendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lähetä uudestaan"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Syötä ja vahvista vastaanotettu todennuskoodi."])}
        },
        "emailOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kirjoita tunnistekoodi"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentikointikoodi sähköpostista"])}
          }
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Lähetä uudelleen ", _interpolate(_named("secondsPlaceholder")), " sekunnin kuluttua"])}
        },
        "emailOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Todennuskoodi sähköpostitse"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vahvista"])}
        }
      },
      "fr-BE": {
        "notification": {
          "emailOTPNotVerified": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])},
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le code d'authentification n'a pas pu être confirmé."])}
          },
          "verifyEmailOTP": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le code d'authentification n'a pas pu être confirmé."])},
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])},
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le code d'authentification est invalide"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])}
            }
          },
          "emailSent": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Action réussie"])},
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le code d'authentification a été envoyé par e-mail. Il ne peut être utilisé qu'une seule fois et dans un délai limité pour l'enregistrement."])}
          },
          "sendEmail": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le code d'authentification a été envoyé par e-mail. Il ne peut être utilisé qu'une seule fois et dans un délai limité pour l'enregistrement."])},
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Le code d'authentification a été envoyé par e-mail à ", _interpolate(_named("primaryEmailAddressPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Action réussie"])}
            },
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Action réussie"])}
          }
        },
        "resendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Renvoyer"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entrez et confirmez le code d'authentification reçu."])}
        },
        "emailOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entrez le code d'authentification"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Code d'authentification de l'email"])}
          }
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Renvoyer dans ", _interpolate(_named("secondsPlaceholder")), " secondes"])}
        },
        "emailOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Code d'authentification par email"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmer"])}
        }
      },
      "fr-CH": {
        "notification": {
          "emailOTPNotVerified": {
            
          },
          "verifyEmailOTP": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le code d'authentification est invalide"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])}
            }
          },
          "emailSent": {
            
          },
          "sendEmail": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Le code d'authentification a été envoyé par e-mail à ", _interpolate(_named("primaryEmailAddressPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Action réussie"])}
            }
          }
        },
        "resendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Renvoyer"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entrez et confirmez le code d'authentification reçu."])}
        },
        "emailOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Saisir le code d'authentification"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Code d'authentification de l'email"])}
          }
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Renvoyer dans ", _interpolate(_named("secondsPlaceholder")), " secondes"])}
        },
        "emailOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Code d'authentification par email"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmer"])}
        }
      },
      "fr-FR": {
        "notification": {
          "emailOTPNotVerified": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])},
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le code d'authentification n'a pas pu être confirmé."])}
          },
          "verifyEmailOTP": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le code d'authentification n'a pas pu être confirmé."])},
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])},
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le code d'authentification est invalide"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])}
            }
          },
          "emailSent": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Action réussie"])},
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le code d'authentification a été envoyé par e-mail. Il ne peut être utilisé qu'une seule fois et dans un délai limité pour l'enregistrement."])}
          },
          "sendEmail": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le code d'authentification a été envoyé par e-mail. Il ne peut être utilisé qu'une seule fois et dans un délai limité pour l'enregistrement."])},
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Le code d'authentification a été envoyé par e-mail à ", _interpolate(_named("primaryEmailAddressPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Action réussie"])}
            },
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Action réussie"])}
          }
        },
        "resendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Envoyer à nouveau"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entrez et confirmez le code d'authentification reçu."])}
        },
        "emailOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Saisir le code d'authentification"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Code d'authentification de l'email"])}
          }
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Renvoyer dans ", _interpolate(_named("secondsPlaceholder")), " secondes"])}
        },
        "emailOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Code d'authentification par email"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmer"])}
        }
      },
      "fr-LU": {
        "notification": {
          "emailOTPNotVerified": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])},
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le code d'authentification n'a pas pu être confirmé."])}
          },
          "verifyEmailOTP": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le code d'authentification n'a pas pu être confirmé."])},
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])},
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le code d'authentification est invalide"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])}
            }
          },
          "emailSent": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Action réussie"])},
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le code d'authentification a été envoyé par e-mail. Il ne peut être utilisé qu'une seule fois et dans un délai limité pour l'enregistrement."])}
          },
          "sendEmail": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le code d'authentification a été envoyé par e-mail. Il ne peut être utilisé qu'une seule fois et dans un délai limité pour l'enregistrement."])},
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Le code d'authentification a été envoyé par e-mail à ", _interpolate(_named("primaryEmailAddressPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Action réussie"])}
            },
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Action réussie"])}
          }
        },
        "resendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Renvoyer"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entrez et confirmez le code d'authentification reçu."])}
        },
        "emailOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Saisir le code d'authentification"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Code d'authentification de l'email"])}
          }
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Renvoyer dans ", _interpolate(_named("secondsPlaceholder")), " secondes"])}
        },
        "emailOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Code d'authentification par email"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmer"])}
        }
      },
      "ga-IE": {
        "notification": {
          "emailOTPNotVerified": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Earráid"])},
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Níorbh fhéidir an cód fíordheimhnithe a dhearbhú."])}
          },
          "verifyEmailOTP": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Níorbh fhéidir an cód fíordheimhnithe a dhearbhú."])},
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Earráid"])},
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tá an cód fíordheimhnithe neamhbhailí"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Earráid"])}
            }
          },
          "emailSent": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gníomh rathúil"])},
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Seoladh an cód fíordheimhnithe trí ríomhphost. Ní féidir é a úsáid ach uair amháin agus laistigh de thréimhse teoranta ama le haghaidh clárúcháin."])}
          },
          "sendEmail": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Seoladh an cód fíordheimhnithe trí ríomhphost. Ní féidir é a úsáid ach uair amháin agus laistigh de thréimhse teoranta ama le haghaidh clárúcháin."])},
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Cuireadh cód fíordheimhnithe tríd an ríomhphost chuig ", _interpolate(_named("primaryEmailAddressPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gníomh rathúil"])}
            },
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gníomh rathúil"])}
          }
        },
        "resendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Seol arís"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cuir isteach agus deimhnigh an cód fíordheimhnithe a fuarthas."])}
        },
        "emailOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cuir isteach cód fíordheimhnithe"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cód authenachta ón ríomhphost"])}
          }
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Athseoladh i ", _interpolate(_named("secondsPlaceholder")), " soicind"])}
        },
        "emailOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cód fíordheimhnithe trí ríomhphost"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deimhnigh"])}
        }
      },
      "he-IL": {
        "notification": {
          "emailOTPNotVerified": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["שְׁגִיאָה"])},
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["לא ניתן היה לאשר את קוד האימות."])}
          },
          "verifyEmailOTP": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["לא ניתן היה לאשר את קוד האימות."])},
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["שְׁגִיאָה"])},
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["קוד האימות אינו חוקי"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["שְׁגִיאָה"])}
            }
          },
          "emailSent": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["פעולה מוצלחת"])},
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["קוד האימות נשלח בדוא＂ל. ניתן להשתמש בו רק פעם אחת ובזמן מוגבל לרישום."])}
          },
          "sendEmail": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["קוד האימות נשלח בדוא＂ל. ניתן להשתמש בו רק פעם אחת ובזמן מוגבל לרישום."])},
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["קוד האימות נשלח בדוא״ל לכתובת ", _interpolate(_named("primaryEmailAddressPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["פעולה מוצלחת"])}
            },
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["פעולה מוצלחת"])}
          }
        },
        "resendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["שלח שוב"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["הזן ואשר את קוד האימות שהתקבל."])}
        },
        "emailOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["הזן קוד אימות"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["קוד אימות מהאימייל"])}
          }
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["שלח מחדש בעוד ", _interpolate(_named("secondsPlaceholder")), " שניות"])}
        },
        "emailOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["קוד אימות במייל"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["לְאַשֵׁר"])}
        }
      },
      "hi-IN": {
        "notification": {
          "emailOTPNotVerified": {
            
          },
          "verifyEmailOTP": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["प्रमाणीकरण कोड अमान्य है"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["त्रुटि"])}
            }
          },
          "emailSent": {
            
          },
          "sendEmail": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("primaryEmailAddressPlaceholder")), " को ईमेल के माध्यम से प्रमाणीकरण कोड भेजा गया है।"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["सफल कार्रवाई"])}
            }
          }
        },
        "resendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["फिर से भेजें"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["प्राप्त प्रमाणीकरण कोड दर्ज करें और पुष्टि करें।"])}
        },
        "emailOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["प्रमाणीकरण कोड दर्ज करें"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ईमेल से प्रमाणीकरण कोड"])}
          }
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("secondsPlaceholder")), " सेकंड में पुन: भेजें"])}
        },
        "emailOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ईमेल द्वारा प्रमाणीकरण कोड"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["पुष्टि करें"])}
        }
      },
      "hr-HR": {
        "notification": {
          "emailOTPNotVerified": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pogreška"])},
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nije moguće potvrditi autentifikacijski kod."])}
          },
          "verifyEmailOTP": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nije moguće potvrditi autentifikacijski kod."])},
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pogreška"])},
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kod za autentifikaciju je nevažeći"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pogreška"])}
            }
          },
          "emailSent": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uspješna akcija"])},
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kod za provjeru autentičnosti poslan je e-poštom. Može se koristiti samo jednom i unutar ograničenog vremena za registraciju."])}
          },
          "sendEmail": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kod za provjeru autentičnosti poslan je e-poštom. Može se koristiti samo jednom i unutar ograničenog vremena za registraciju."])},
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Autentikacijski kod poslan je e-mailom na ", _interpolate(_named("primaryEmailAddressPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uspješna akcija"])}
            },
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uspješna akcija"])}
          }
        },
        "resendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pošalji opet"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unesite i potvrdite primljeni autentifikacijski kod."])}
        },
        "emailOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unesite autentifikacijski kod"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikacijski kôd iz e-maila"])}
          }
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Ponovno pošalji za ", _interpolate(_named("secondsPlaceholder")), " sekundi"])}
        },
        "emailOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikacijski kod e-poštom"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Potvrda"])}
        }
      },
      "hu-HU": {
        "notification": {
          "emailOTPNotVerified": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hiba"])},
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["A hitelesítő kódot nem sikerült megerősíteni."])}
          },
          "verifyEmailOTP": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["A hitelesítő kódot nem sikerült megerősíteni."])},
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hiba"])},
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Az hitelesítési kód érvénytelen"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hiba"])}
            }
          },
          "emailSent": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sikeres művelet"])},
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["A hitelesítési kódot e-mailben küldték el. Csak egyszer és korlátozott ideig használható fel regisztrációhoz."])}
          },
          "sendEmail": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["A hitelesítési kódot e-mailben küldték el. Csak egyszer és korlátozott ideig használható fel regisztrációhoz."])},
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Az hitelesítő kódot emailben küldtük el a ", _interpolate(_named("primaryEmailAddressPlaceholder")), " címre."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sikeres művelet"])}
            },
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sikeres művelet"])}
          }
        },
        "resendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Küldd újra"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Írja be és erősítse meg a kapott hitelesítési kódot."])}
        },
        "emailOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Adja meg az hitelesítő kódot"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hitelesítő kód az e-mailből"])}
          }
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Újraküldés ", _interpolate(_named("secondsPlaceholder")), " másodperc múlva"])}
        },
        "emailOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hitelesítési kód e-mailben"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Megerősít"])}
        }
      },
      "it-CH": {
        "notification": {
          "emailOTPNotVerified": {
            
          },
          "verifyEmailOTP": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Il codice di autenticazione non è valido"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Errore"])}
            }
          },
          "emailSent": {
            
          },
          "sendEmail": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Il codice di autenticazione è stato inviato tramite email a ", _interpolate(_named("primaryEmailAddressPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Azione di successo"])}
            }
          }
        },
        "resendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Invia di nuovo"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inserisci e conferma il codice di autenticazione ricevuto."])}
        },
        "emailOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inserire il codice di autenticazione"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Codice di autenticazione dall'email"])}
          }
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Invia di nuovo fra ", _interpolate(_named("secondsPlaceholder")), " secondi"])}
        },
        "emailOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Codice di autenticazione via e-mail"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confermare"])}
        }
      },
      "it-IT": {
        "notification": {
          "emailOTPNotVerified": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Errore"])},
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Non è stato possibile confermare il codice di autenticazione."])}
          },
          "verifyEmailOTP": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Non è stato possibile confermare il codice di autenticazione."])},
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Errore"])},
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Il codice di autenticazione non è valido"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Errore"])}
            }
          },
          "emailSent": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Azione riuscita"])},
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Il codice di autenticazione è stato inviato via e-mail. Può essere utilizzato solo una volta ed entro un tempo limitato per la registrazione."])}
          },
          "sendEmail": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Il codice di autenticazione è stato inviato via e-mail. Può essere utilizzato solo una volta ed entro un tempo limitato per la registrazione."])},
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Il codice di autenticazione è stato inviato per email a ", _interpolate(_named("primaryEmailAddressPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Azione riuscita"])}
            },
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Azione riuscita"])}
          }
        },
        "resendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Invia di nuovo"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inserisci e conferma il codice di autenticazione ricevuto."])}
        },
        "emailOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inserire il codice di autenticazione"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Codice di autenticazione dall'email"])}
          }
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Invia di nuovo fra ", _interpolate(_named("secondsPlaceholder")), " secondi"])}
        },
        "emailOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Codice di autenticazione via e-mail"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Conferma"])}
        }
      },
      "ja-JP": {
        "notification": {
          "emailOTPNotVerified": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["エラー"])},
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["認証コードが確認できませんでした。"])}
          },
          "verifyEmailOTP": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["認証コードが確認できませんでした。"])},
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["エラー"])},
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["認証コードが無効です"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["エラー"])}
            }
          },
          "emailSent": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["成功したアクション"])},
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["認証コードはメールで送信されました。 1回のみ利用可能で、登録の制限時間内に利用できます。"])}
          },
          "sendEmail": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["認証コードはメールで送信されました。 1回のみ利用可能で、登録の制限時間内に利用できます。"])},
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["認証コードが", _interpolate(_named("primaryEmailAddressPlaceholder")), "に電子メールで送信されました。"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["成功したアクション"])}
            },
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["成功したアクション"])}
          }
        },
        "resendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["もう一度送信"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["受信した認証コードを入力して確認します。"])}
        },
        "emailOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["認証コードを入力してください"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["メールからの認証コード"])}
          }
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("secondsPlaceholder")), " 秒後に再送信"])}
        },
        "emailOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["メールによる認証コード"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["確認"])}
        }
      },
      "ko-KR": {
        "notification": {
          "emailOTPNotVerified": {
            
          },
          "verifyEmailOTP": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["인증 코드가 유효하지 않습니다"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["오류"])}
            }
          },
          "emailSent": {
            
          },
          "sendEmail": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["인증 코드가 ", _interpolate(_named("primaryEmailAddressPlaceholder")), "로 이메일로 전송되었습니다."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["성공적인 액션"])}
            }
          }
        },
        "resendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["다시 보내기"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["받은 인증 코드를 입력하고 확인하십시오."])}
        },
        "emailOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["인증 코드를 입력하세요"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["이메일로부터의 인증 코드"])}
          }
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("secondsPlaceholder")), "초 후에 재전송"])}
        },
        "emailOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["이메일을 통한 인증 코드"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["확인"])}
        }
      },
      "lt-LT": {
        "notification": {
          "emailOTPNotVerified": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Klaida"])},
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nepavyko patvirtinti autentifikavimo kodo."])}
          },
          "verifyEmailOTP": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nepavyko patvirtinti autentifikavimo kodo."])},
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Klaida"])},
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikacijos kodas netinkamas"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Klaida"])}
            }
          },
          "emailSent": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sėkmingas veiksmas"])},
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikavimo kodas buvo išsiųstas el. paštu. Jį galima naudoti tik vieną kartą ir per ribotą registracijos laiką."])}
          },
          "sendEmail": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikavimo kodas buvo išsiųstas el. paštu. Jį galima naudoti tik vieną kartą ir per ribotą registracijos laiką."])},
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Autentifikacijos kodas išsiųstas el. paštu į ", _interpolate(_named("primaryEmailAddressPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sėkmingas veiksmas"])}
            },
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sėkmingas veiksmas"])}
          }
        },
        "resendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Siųsti dar kartą"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Įveskite ir patvirtinkite gautą autentifikavimo kodą."])}
        },
        "emailOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Įveskite autentifikacijos kodą"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikavimo kodas iš el. pašto"])}
          }
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Persiųsti po ", _interpolate(_named("secondsPlaceholder")), " sekundžių"])}
        },
        "emailOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikavimo kodas el. Paštu"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Patvirtinti"])}
        }
      },
      "lv-LV": {
        "notification": {
          "emailOTPNotVerified": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kļūda"])},
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nevarēja apstiprināt autentifikācijas kodu."])}
          },
          "verifyEmailOTP": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nevarēja apstiprināt autentifikācijas kodu."])},
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kļūda"])},
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikācijas kods ir nederīgs"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kļūda"])}
            }
          },
          "emailSent": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Veiksmīga darbība"])},
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikācijas kods tika nosūtīts pa e-pastu. To var izmantot tikai vienu reizi un ierobežotā reģistrācijas laikā."])}
          },
          "sendEmail": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikācijas kods tika nosūtīts pa e-pastu. To var izmantot tikai vienu reizi un ierobežotā reģistrācijas laikā."])},
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Autentifikācijas kods ir nosūtīts uz ", _interpolate(_named("primaryEmailAddressPlaceholder")), " pa e-pastu."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Veiksmīga darbība"])}
            },
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Veiksmīga darbība"])}
          }
        },
        "resendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sūtīt vēlreiz"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ievadiet un apstipriniet saņemto autentifikācijas kodu."])}
        },
        "emailOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ievadiet autentifikācijas kodu"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikācijas kods no e-pasta"])}
          }
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Atkārtoti nosūtīt pēc ", _interpolate(_named("secondsPlaceholder")), " sekundēm"])}
        },
        "emailOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikācijas kods pa e-pastu"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Apstiprināt"])}
        }
      },
      "mt-MT": {
        "notification": {
          "emailOTPNotVerified": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Żball"])},
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Il-kodiċi ta' awtentikazzjoni ma setax jiġi kkonfermat."])}
          },
          "verifyEmailOTP": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Il-kodiċi ta' awtentikazzjoni ma setax jiġi kkonfermat."])},
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Żball"])},
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Il-kodiċi ta' awtentiċità mhux validu"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Żball"])}
            }
          },
          "emailSent": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Azzjoni ta' suċċess"])},
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Il-kodiċi ta' awtentikazzjoni ntbagħat permezz ta' email. Jista' jintuża darba biss u fi żmien limitat għar-reġistrazzjoni."])}
          },
          "sendEmail": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Il-kodiċi ta' awtentikazzjoni ntbagħat permezz ta' email. Jista' jintuża darba biss u fi żmien limitat għar-reġistrazzjoni."])},
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Il-kodiċi ta' awtentikazzjoni ġie mibgħut permezz ta' email għal ", _interpolate(_named("primaryEmailAddressPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Azzjoni ta' suċċess"])}
            },
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Azzjoni ta' suċċess"])}
          }
        },
        "resendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ibgħat mill-ġdid"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Daħħal u kkonferma l-kodiċi ta 'awtentikazzjoni riċevut."])}
        },
        "emailOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Idħol il-kodiċi ta' awtentikazzjoni"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kodiċi ta' awtentikazzjoni mill-email"])}
          }
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Ibgħat mill-ġdid fi ", _interpolate(_named("secondsPlaceholder")), " sekondi"])}
        },
        "emailOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kodiċi ta 'awtentikazzjoni bl-email"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ikkonferma"])}
        }
      },
      "nb-NO": {
        "notification": {
          "emailOTPNotVerified": {
            
          },
          "verifyEmailOTP": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentiseringskoden er ugyldig"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Feil"])}
            }
          },
          "emailSent": {
            
          },
          "sendEmail": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Bekreftelseskoden er sendt på e-post til ", _interpolate(_named("primaryEmailAddressPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vellykket handling"])}
            }
          }
        },
        "resendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Send igjen"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Skriv inn og bekreft autentiseringskoden du mottok."])}
        },
        "emailOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Skriv inn godkjenningskode"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentiseringskode fra e-post"])}
          }
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Send på nytt om ", _interpolate(_named("secondsPlaceholder")), " sekunder"])}
        },
        "emailOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentiseringskode via e-post"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bekrefte"])}
        }
      },
      "nl-BE": {
        "notification": {
          "emailOTPNotVerified": {
            
          },
          "verifyEmailOTP": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["De verificatiecode is ongeldig"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fout"])}
            }
          },
          "emailSent": {
            
          },
          "sendEmail": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["De authenticatiecode is per e-mail verzonden naar ", _interpolate(_named("primaryEmailAddressPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Geslaagde actie"])}
            }
          }
        },
        "resendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Opnieuw verzenden"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Voer de ontvangen authenticatiecode in en bevestig deze."])}
        },
        "emailOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Voer de authenticatiecode in"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authenticatiecode van e-mail"])}
          }
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Opnieuw verzenden over ", _interpolate(_named("secondsPlaceholder")), " seconden"])}
        },
        "emailOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authenticatiecode per e-mail"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bevestigen"])}
        }
      },
      "nl-NL": {
        "notification": {
          "emailOTPNotVerified": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fout"])},
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["De authencitatiecode kon niet worden bevestigd."])}
          },
          "verifyEmailOTP": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["De authencitatiecode kon niet worden bevestigd."])},
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fout"])},
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["De verificatiecode is ongeldig"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fout"])}
            }
          },
          "emailSent": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Geslaagde actie"])},
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["De authenticatiecode is per e-mail verzonden. Het kan slechts één keer en binnen een beperkte tijd worden gebruikt voor registratie."])}
          },
          "sendEmail": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["De authenticatiecode is per e-mail verzonden. Het kan slechts één keer en binnen een beperkte tijd worden gebruikt voor registratie."])},
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["De authenticatiecode is per e-mail verzonden naar ", _interpolate(_named("primaryEmailAddressPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Geslaagde actie"])}
            },
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Geslaagde actie"])}
          }
        },
        "resendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Opnieuw verzenden"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Voer de ontvangen authenticatiecode in en bevestig deze."])}
        },
        "emailOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Voer de authenticatiecode in"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authenticatiecode van e-mail"])}
          }
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Opnieuw verzenden over ", _interpolate(_named("secondsPlaceholder")), " seconden"])}
        },
        "emailOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authenticatiecode per e-mail"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bevestigen"])}
        }
      },
      "pl-PL": {
        "notification": {
          "emailOTPNotVerified": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Błąd"])},
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nie udało się potwierdzić kodu uwierzytelniającego."])}
          },
          "verifyEmailOTP": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nie udało się potwierdzić kodu uwierzytelniającego."])},
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Błąd"])},
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kod uwierzytelniania jest nieprawidłowy"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Błąd"])}
            }
          },
          "emailSent": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Czynność zakończona powodzeniem"])},
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kod uwierzytelniający został wysłany e-mailem. Można go użyć tylko raz iw ograniczonym czasie do rejestracji."])}
          },
          "sendEmail": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kod uwierzytelniający został wysłany e-mailem. Można go użyć tylko raz iw ograniczonym czasie do rejestracji."])},
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Kod uwierzytelniający został wysłany e-mailem na ", _interpolate(_named("primaryEmailAddressPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Czynność zakończona powodzeniem"])}
            },
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Czynność zakończona powodzeniem"])}
          }
        },
        "resendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wyślij ponownie"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wprowadź i potwierdź otrzymany kod uwierzytelniający."])}
        },
        "emailOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wprowadź kod uwierzytelniania"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kod uwierzytelniania z e-maila"])}
          }
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Wyślij ponownie za ", _interpolate(_named("secondsPlaceholder")), " sekund"])}
        },
        "emailOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kod uwierzytelniający przez e-mail"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Potwierdź"])}
        }
      },
      "pt-PT": {
        "notification": {
          "emailOTPNotVerified": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erro"])},
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Não foi possível confirmar o código de autenticação."])}
          },
          "verifyEmailOTP": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Não foi possível confirmar o código de autenticação."])},
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erro"])},
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["O código de autenticação é inválido"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erro"])}
            }
          },
          "emailSent": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ação bem-sucedida"])},
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["O código de autenticação foi enviado por e-mail. Ele só pode ser usado uma vez e dentro de um tempo limitado para registro."])}
          },
          "sendEmail": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["O código de autenticação foi enviado por e-mail. Ele só pode ser usado uma vez e dentro de um tempo limitado para registro."])},
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["O código de autenticação foi enviado por e-mail para ", _interpolate(_named("primaryEmailAddressPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ação bem-sucedida"])}
            },
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ação bem-sucedida"])}
          }
        },
        "resendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Envie novamente"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Digite e confirme o código de autenticação recebido."])}
        },
        "emailOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Insira o código de autenticação"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Código de autenticação do email"])}
          }
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Reenviar em ", _interpolate(_named("secondsPlaceholder")), " segundos"])}
        },
        "emailOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Código de autenticação por email"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmar"])}
        }
      },
      "ro-RO": {
        "notification": {
          "emailOTPNotVerified": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eroare"])},
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Codul de autentificare nu a putut fi confirmat."])}
          },
          "verifyEmailOTP": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Codul de autentificare nu a putut fi confirmat."])},
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eroare"])},
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Codul de autentificare este invalid"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eroare"])}
            }
          },
          "emailSent": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Acțiune reușită"])},
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Codul de autentificare a fost trimis prin e-mail. Poate fi folosit o singură dată și într-un timp limitat pentru înregistrare."])}
          },
          "sendEmail": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Codul de autentificare a fost trimis prin e-mail. Poate fi folosit o singură dată și într-un timp limitat pentru înregistrare."])},
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Codul de autentificare a fost trimis prin e-mail la ", _interpolate(_named("primaryEmailAddressPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Acțiune reușită"])}
            },
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Acțiune reușită"])}
          }
        },
        "resendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Trimite din nou"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Introduceți și confirmați codul de autentificare primit."])}
        },
        "emailOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Introduceți codul de autentificare"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Codul de autentificare din email"])}
          }
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Retrimite în ", _interpolate(_named("secondsPlaceholder")), " secunde"])}
        },
        "emailOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cod de autentificare prin e-mail"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmare"])}
        }
      },
      "ru-RU": {
        "notification": {
          "emailOTPNotVerified": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ошибка"])},
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Код аутентификации не подтвержден."])}
          },
          "verifyEmailOTP": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Код аутентификации не подтвержден."])},
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ошибка"])},
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Код аутентификации недействителен"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ошибка"])}
            }
          },
          "emailSent": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Успешное действие"])},
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Код аутентификации был отправлен по электронной почте. Его можно использовать только один раз и в течение ограниченного времени регистрации."])}
          },
          "sendEmail": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Код аутентификации был отправлен по электронной почте. Его можно использовать только один раз и в течение ограниченного времени регистрации."])},
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Код аутентификации был отправлен по электронной почте на ", _interpolate(_named("primaryEmailAddressPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Успешное действие"])}
            },
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Успешное действие"])}
          }
        },
        "resendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Отправь еще раз"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Введите и подтвердите полученный код аутентификации."])}
        },
        "emailOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Введите код аутентификации"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Код аутентификации из электронной почты"])}
          }
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Отправить снова через ", _interpolate(_named("secondsPlaceholder")), " секунд"])}
        },
        "emailOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Код аутентификации по электронной почте"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Подтвердить"])}
        }
      },
      "sk-SK": {
        "notification": {
          "emailOTPNotVerified": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chyba"])},
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Overovací kód nebolo možné potvrdiť."])}
          },
          "verifyEmailOTP": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Overovací kód nebolo možné potvrdiť."])},
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chyba"])},
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikačný kód je neplatný"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chyba"])}
            }
          },
          "emailSent": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Úspešná akcia"])},
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Overovací kód bol odoslaný e-mailom. Môže byť použitý iba raz a v obmedzenom čase na registráciu."])}
          },
          "sendEmail": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Overovací kód bol odoslaný e-mailom. Môže byť použitý iba raz a v obmedzenom čase na registráciu."])},
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Autentifikačný kód bol odoslaný e-mailom na adresu ", _interpolate(_named("primaryEmailAddressPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Úspešná akcia"])}
            },
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Úspešná akcia"])}
          }
        },
        "resendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Poslať znova"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zadajte a potvrďte prijatý overovací kód."])}
        },
        "emailOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zadajte overovací kód"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikačný kód z e-mailu"])}
          }
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Znovu poslať o ", _interpolate(_named("secondsPlaceholder")), " sekundy"])}
        },
        "emailOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikačný kód e-mailom"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Potvrdiť"])}
        }
      },
      "sl-SI": {
        "notification": {
          "emailOTPNotVerified": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Napaka"])},
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kode za preverjanje pristnosti ni bilo mogoče potrditi."])}
          },
          "verifyEmailOTP": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kode za preverjanje pristnosti ni bilo mogoče potrditi."])},
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Napaka"])},
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Koda za overitev je neveljavna"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Napaka"])}
            }
          },
          "emailSent": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uspešno opravljeno"])},
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Koda za preverjanje pristnosti je bila poslana po e-pošti. Uporablja se lahko samo enkrat in v omejenem času za registracijo."])}
          },
          "sendEmail": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Koda za preverjanje pristnosti je bila poslana po e-pošti. Uporablja se lahko samo enkrat in v omejenem času za registracijo."])},
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Koda za overitev je bila poslana po e-pošti na ", _interpolate(_named("primaryEmailAddressPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uspešno opravljeno"])}
            },
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uspešno opravljeno"])}
          }
        },
        "resendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pošlji ponovno"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vnesite in potrdite prejeto kodo za preverjanje pristnosti."])}
        },
        "emailOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vnesite kodo za preverjanje pristnosti"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Avtentikacijska koda iz e-pošte"])}
          }
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Ponovno pošlji čez ", _interpolate(_named("secondsPlaceholder")), " sekund"])}
        },
        "emailOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Koda za preverjanje pristnosti po e-pošti"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Potrdi"])}
        }
      },
      "sv-SE": {
        "notification": {
          "emailOTPNotVerified": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fel"])},
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentiseringskoden kunde inte bekräftas."])}
          },
          "verifyEmailOTP": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentiseringskoden kunde inte bekräftas."])},
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fel"])},
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentiseringskoden är ogiltig"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fel"])}
            }
          },
          "emailSent": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Åtgärd utförd"])},
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentiseringskoden skickades via e-post. Den kan endast användas en gång och inom en begränsad tid för registrering."])}
          },
          "sendEmail": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentiseringskoden skickades via e-post. Den kan endast användas en gång och inom en begränsad tid för registrering."])},
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Autentiseringskoden har skickats med e-post till ", _interpolate(_named("primaryEmailAddressPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Åtgärd utförd"])}
            },
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Åtgärd utförd"])}
          }
        },
        "resendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Skicka igen"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ange och bekräfta den mottagna autentiseringskoden."])}
        },
        "emailOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ange autentiseringskod"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentiseringskod från e-post"])}
          }
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Skicka igen om ", _interpolate(_named("secondsPlaceholder")), " sekunder"])}
        },
        "emailOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentiseringskod via e-post"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bekräfta"])}
        }
      },
      "th-TH": {
        "notification": {
          "emailOTPNotVerified": {
            
          },
          "verifyEmailOTP": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["รหัสการตรวจสอบไม่ถูกต้อง"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ความผิดพลาด"])}
            }
          },
          "emailSent": {
            
          },
          "sendEmail": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["รหัสการรับรองความถูกต้องได้ถูกส่งไปทางอีเมลไปยัง ", _interpolate(_named("primaryEmailAddressPlaceholder"))])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["การดำเนินการที่ประสบความสำเร็จ"])}
            }
          }
        },
        "resendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ส่งอีกครั้ง"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ป้อนและยืนยันรหัสการรับรองที่ได้รับ"])}
        },
        "emailOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ป้อนรหัสยืนยัน"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["รหัสการยืนยันจากอีเมล"])}
          }
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["ส่งใหม่ใน ", _interpolate(_named("secondsPlaceholder")), " วินาที"])}
        },
        "emailOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["รหัสการยืนยันผ่านอีเมล"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ยืนยัน"])}
        }
      },
      "tr-CY": {
        "notification": {
          "emailOTPNotVerified": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hata"])},
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kimlik doğrulama kodu onaylanamadı."])}
          },
          "verifyEmailOTP": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kimlik doğrulama kodu onaylanamadı."])},
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hata"])},
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Doğrulama kodu geçersiz"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hata"])}
            }
          },
          "emailSent": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Başarılı eylem"])},
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kimlik doğrulama kodu e-posta yoluyla gönderildi. Kayıt için yalnızca bir kez ve sınırlı bir süre içinde kullanılabilir."])}
          },
          "sendEmail": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kimlik doğrulama kodu e-posta yoluyla gönderildi. Kayıt için yalnızca bir kez ve sınırlı bir süre içinde kullanılabilir."])},
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("primaryEmailAddressPlaceholder")), " adresine e-posta ile doğrulama kodu gönderilmiştir."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Başarılı eylem"])}
            },
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Başarılı eylem"])}
          }
        },
        "resendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tekrar gönderin"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Alınan doğrulama kodunu girin ve onaylayın."])}
        },
        "emailOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Doğrulama kodunu girin"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-postadan doğrulama kodu"])}
          }
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("secondsPlaceholder")), " saniye sonra yeniden gönder"])}
        },
        "emailOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-posta ile kimlik doğrulama kodu"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Onayla"])}
        }
      },
      "tr-TR": {
        "notification": {
          "emailOTPNotVerified": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hata"])},
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kimlik doğrulama kodu onaylanamadı."])}
          },
          "verifyEmailOTP": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kimlik doğrulama kodu onaylanamadı."])},
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hata"])},
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Doğrulama kodu geçersiz"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hata"])}
            }
          },
          "emailSent": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Başarılı eylem"])},
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kimlik doğrulama kodu e-posta yoluyla gönderildi. Kayıt için yalnızca bir kez ve sınırlı bir süre içinde kullanılabilir."])}
          },
          "sendEmail": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kimlik doğrulama kodu e-posta yoluyla gönderildi. Kayıt için yalnızca bir kez ve sınırlı bir süre içinde kullanılabilir."])},
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("primaryEmailAddressPlaceholder")), " adresine e-posta ile doğrulama kodu gönderilmiştir."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Başarılı eylem"])}
            },
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Başarılı eylem"])}
          }
        },
        "resendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tekrar gönderin"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Alınan doğrulama kodunu girin ve onaylayın."])}
        },
        "emailOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Doğrulama kodunu girin"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-postadan doğrulama kodu"])}
          }
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("secondsPlaceholder")), " saniye sonra yeniden gönder"])}
        },
        "emailOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-posta ile kimlik doğrulama kodu"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Onayla"])}
        }
      },
      "uk-UA": {
        "notification": {
          "emailOTPNotVerified": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Помилка"])},
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Не вдалося підтвердити код автентифікації."])}
          },
          "verifyEmailOTP": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Не вдалося підтвердити код автентифікації."])},
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Помилка"])},
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Код автентифікації недійсний"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Помилка"])}
            }
          },
          "emailSent": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Успішна акція"])},
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Код автентифікації надіслано електронною поштою. Його можна використовувати лише один раз і протягом обмеженого часу для реєстрації."])}
          },
          "sendEmail": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Код автентифікації надіслано електронною поштою. Його можна використовувати лише один раз і протягом обмеженого часу для реєстрації."])},
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Код підтвердження був відправлено електронною поштою на ", _interpolate(_named("primaryEmailAddressPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Успішна дія"])}
            },
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Успішна акція"])}
          }
        },
        "resendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Надіслати знову"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Введіть і підтвердьте отриманий код автентифікації."])}
        },
        "emailOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Введіть код автентифікації"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Код автентифікації з електронної пошти"])}
          }
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Надіслати знову за ", _interpolate(_named("secondsPlaceholder")), " секунд"])}
        },
        "emailOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Код автентифікації електронною поштою"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Підтвердити"])}
        }
      },
      "vi-VN": {
        "notification": {
          "emailOTPNotVerified": {
            
          },
          "verifyEmailOTP": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mã xác thực không hợp lệ"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lỗi"])}
            }
          },
          "emailSent": {
            
          },
          "sendEmail": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Mã xác thực đã được gửi qua email đến ", _interpolate(_named("primaryEmailAddressPlaceholder")), "."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hành động thành công"])}
            }
          }
        },
        "resendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gửi lại"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nhập và xác nhận mã xác thực đã nhận."])}
        },
        "emailOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nhập mã xác thực"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mã xác thực từ email"])}
          }
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Gửi lại sau ", _interpolate(_named("secondsPlaceholder")), " giây"])}
        },
        "emailOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mã xác thực qua email"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Xác nhận"])}
        }
      },
      "zh-CN": {
        "notification": {
          "emailOTPNotVerified": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["错误"])},
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["无法确认验证码。"])}
          },
          "verifyEmailOTP": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["无法确认验证码。"])},
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["错误"])},
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["认证代码无效"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["错误"])}
            }
          },
          "emailSent": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["操作成功"])},
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["验证码是通过电子邮件发送的。 注册后限时使用一次。"])}
          },
          "sendEmail": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["验证码是通过电子邮件发送的。 注册后限时使用一次。"])},
            "success": {
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["认证码已通过电子邮件发送到", _interpolate(_named("primaryEmailAddressPlaceholder")), "。"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["操作成功"])}
            },
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["操作成功"])}
          }
        },
        "resendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["重新发送"])}
        },
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["输入并确认收到的验证码。"])}
        },
        "emailOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["请输入认证码"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["电子邮件中的认证码"])}
          }
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("secondsPlaceholder")), " 秒后重新发送"])}
        },
        "emailOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["通过电子邮件验证代码"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["确认"])}
        }
      }
    }
  })
}
